import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { SessionValues } from './sessionvalues.service';

@Injectable({
  providedIn: 'root'
})
export class BaseUrlService {

  public GenerateBaseUrl(): string {
    return environment.apiBaseUrl;
  }

  public GenerateImageBaseUrl(): string {
    const baseUrlWithController = SessionValues.GetInstance().requestController;
    const imageBaseUrl = `${baseUrlWithController}${environment.imageBasePath}`;
    return imageBaseUrl;
  }

  public GenerateImageBaseUrlWithoutLoginToken(): string {
    const baseUrlWithController = SessionValues.GetInstance().requestController;
    const imageBaseUrl = `${baseUrlWithController}${environment.imageBasePathwithoutlogintoken}`;
    return imageBaseUrl;
  }
}






// import { Injectable } from '@angular/core';
// import { environment } from '../../environments/environment'; // adjust path if needed
// import { SessionValues } from './sessionvalues.service';

// @Injectable({
//   providedIn: 'root'
// })

// export class BaseUrlService {
//   public get isConnectedLocally() {
//     return location.origin.includes('localhost')
//       || location.origin.includes('127.0.0.1');
//   }

//   public GenerateBaseUrl() {
//     // let baseURLstring = `https://ccapi.velocetech.space`;  //For Live
//     let baseURLstring = `http://192.168.29.68:5000`; //For Frontend Developers
//     return baseURLstring;
//   }


//    public GenerateImageBaseUrl() {
//     let baseUrlWithController = SessionValues.GetInstance().mobileApp;
//     let ImageBaseUrl = `${baseUrlWithController}/uploadeddocumentpath/`;         // for both Live and Frontend //
//     return ImageBaseUrl;
//   }
// }
